export const API_KEY = "AIzaSyASKdDrL7DCF2ZtuSC3bk3uVM_6Fg1FUao";
export const APP_ID = "1:29441915929:web:0fc2781c898c2913333e88";
export const MEASUREMENT_ID = "G-E5248G8JC5";
export const BUCKET_URL = "co-reality-map.appspot.com";
export const PROJECT_ID = "co-reality-map";
